import React from "react";
import styled from "styled-components";
import tw from "twin.macro";

const NavContainer = styled.div`
  min-width: 320px;

  ${tw`
    bg-black
    text-white
    flex
    justify-center
    items-center
    h-8
    text-sm
    uppercase
    font-bold
    w-full
    
    sm:h-14
    sm:text-4xl
    sm:border-b-2
    sm:border-white
    `}
`

export default function Navbar() {

    return (
        <>
            <NavContainer>
                Wordle Clone
            </NavContainer>
        </>
    )
}
